import { currentTenant } from '@/constants'
export default {
  SET_DICTDATA (state, { data }) {
    state.dictData = data
  },
  SET_TENANT (state, data) {
    // 防刷新丢失
    window.sessionStorage.setItem(currentTenant, JSON.stringify(data))
    state.tenant.tenantId = data.tenantCode
    // state.tenant.tenantName = data.tenantName
    state.tenant.config.map.key = data.gaodeJsApiKey || ''
    state.tenant.config.weixin.name = data.tenantName || ''
    state.tenant.config.weixin.qrcode = data.tenantName || ''
  },
  SET_USERINFO (state, { data }) {
    state.userData = data
  },
  /* 保存陪审员信息 */
  SET_JUROR_INFO (state, { data }) {
    state.jurorInfo = data
  },
  // 保存用户的头像
  SET_USER_AVATAR (state, { data }) {
    state.userAvatar = data
  },
  SET_CORPID (state, value) {
    window.sessionStorage.setItem('corpId', value)
    state.corpId = value
  },
  Add_DDCOUNT (state, value) {
    window.sessionStorage.setItem('ddCount', ++state.ddCount)
  },
  SET_ROLES (state, { data }) {
    state.roles = data
  },
  SET_USER_DATA (state, { data }) {
    state.userInfo = data
  },
  UPDATE_IS_ADDED_ROUTES (state, value) {
    state.isAddedRoutes = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js